<ion-header>
	<app-navheader></app-navheader>
	<ion-item>
    <ion-label> <h1>LES ARCHIVES</h1></ion-label>
  </ion-item>
</ion-header>
<ion-content>
	<ion-card>
		<ion-card-content>
			<div class="archives-up">
			<div class="title" (click) = "goToNewsPapers()">
				<h2>Mes archives PDF</h2>
				<ion-icon class="fiches-arrow-right"></ion-icon>
			</div>
				<div class="archives-text">
					Rechercher tous les numéros inclus depuis le début de votre abonnement.
				</div>
			</div>
			<div class="archives-down">
				<h2>Toutes les archives PlayBac Presse</h2>
				<div class="archives-text">
					Grâce à votre abonnement au cartable digital, vous pouvez consulter toutes les archives de PlayBac Presse.
				</div>
			</div>
			<ion-button class="gotoarchives" (click)="goToArchivesSite()">Accéder au site archives</ion-button>
		</ion-card-content>
	</ion-card>
	<app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer>
	<app-bottom-menu [isActive]="isActivePage"></app-bottom-menu>
</ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" #temppopup></app-pop-up>
